import React, { useEffect, useState } from "react";
import Bet_Diskon from "./FourDThreeDTwoDSubComponents/Bet_Diskon";
import Bet_Full from "./FourDThreeDTwoDSubComponents/Bet_Full";
import Prize from './FourDThreeDTwoDSubComponents/Prize'
import FourDThreeDTwoDBetDiscountVersiWap from './FourDThreeDTwoDSubComponents/FourDThreeDTwoDBetDiscountVersiWap'
import { useDispatch, useSelector } from "react-redux";
import FourDThreeDTwoDBetFullVersiWap from "./FourDThreeDTwoDSubComponents/FourDThreeDTwoDBetFullVersiWap";
import FourDThreeDTwoDPrizeVersiWap from "./FourDThreeDTwoDSubComponents/FourDThreeDTwoDPrizeVersiWap";
import VersiWAP from "../../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo";
import Rules from "../../../MobileDesign/FourDMo/Rules/Rules";
import { set4dGameSubChildtype, setCommonConfig } from "../../../../../redux/actions";
import MarketClose from "../../MarketClose";
import ZeroBalancePopup from "../../ZeroBalancePopup";
import GameClosedPopup from "../../GameClosedPopup";
import { withTranslation } from "react-i18next";
import { MdKeyboardArrowRight } from "react-icons/md";
import { TbBulb } from "react-icons/tb";
import CoachMarkPopup from "../../../../Popups/CoachMarkPopup";


const FourDThreeDTwoD = (props) => {
  const dispatch = useDispatch();

  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const marketStatus = useSelector((state) => state.CommonConfig.discount)
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const user_profile = useSelector(state => state.UserProfile);
  const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
  const clickTab = useSelector((state) => state.CommonConfig.clickTab);
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  


  const [activeTab, setActiveTab] = useState(1);

  const betDiscount = useSelector((state) => state.CommonConfig.discount);  
  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');

  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = betDiscount.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = betDiscount.showMultipleFullbet;
    } else {
      multiple = betDiscount.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type, betDiscount]);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: tabIndex == "1" ? "DISCOUNT" : tabIndex == "2" ? "FULLBET" : tabIndex == "3" ? "PRIZE" : "" }));
  };

  useEffect(() => {
    setActiveTab(1)
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
  }, [gameId])

  useEffect(() => {
    setActiveTab(1);
    dispatch(setCommonConfig({ key: 'gameType', value: '4d3d2d' }));
    dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
    dispatch(setCommonConfig({ key: 'clickTab', value: 0 }));
  }, [clickTab])

  return (
    <>
      <div className="inner_nav-tabwrapper"  >
        {marketStatus.fullbetStatus == 0 && marketStatus.prize123Status == 0 ? '' :

          <div
            className={`inner_tab custom-tooltip-wrapper ${activeTab === 1 ? "active" : ""}`}
            onClick={() => handleTabClick(1)}
          > DISCOUNT
            {/* <div className="custom-tooltip">
                <div className="quick-tip">
                  <TbBulb />
                  <span>Quick tip 1/11</span>
                </div>
                <div className="text">Markets</div>
                <p className="market-bet">Select your betting market.</p>
                <div className="custom-action">
                  <div className="custom-bet">SKIP ALL</div>
                  <div className="custom-bet">
                    NEXT
                    <div className="right-arr">
                      <MdKeyboardArrowRight />
                    </div>
                  </div>
                </div>

                <span className="custom-tooltip-arrow"></span>
              </div> */}
          </div>
        }
        {marketStatus.fullbetStatus == 0 ? '' :


          <div
            className={`inner_tab custom-tooltip-wrapper ${activeTab === 2 ? "active" : ""}`}
            onClick={() => handleTabClick(2)}
          >
            FULLBET
            <div className="custom-tooltip">
              <div className="quick-tip">
                <TbBulb />
                <span>Quick tip 1/11</span>
              </div>
              <div className="text">Markets</div>
              <p className="market-bet">Select your betting market.</p>
              <div className="custom-action">
                <div className="custom-bet">SKIP ALL</div>
                <div className="custom-bet">
                  NEXT
                  <div className="right-arr">
                    <MdKeyboardArrowRight />
                  </div>
                </div>
              </div>

              <span className="custom-tooltip-arrow"></span>
            </div>
          </div>
        }
        {marketStatus.prize123Status == 0 ? '' :
          <div
            className={`inner_tab ${activeTab === 3 ? "active" : ""}`}
            onClick={() => handleTabClick(3)}
          >
            PRIZE 1,2,3
          </div>
        }
      </div>
      {
        device === "Mobile" ? (
          <>
            {/* <VersiWAP /> */}
            {/* <Rules /> */}
            {app_type === "wap" ?
              <div className='rules_container'>
                <div>
                  <p>{props.t('guess_exact_number')}</p>
                  <p>Format Taruhan: nomor1*nomor2*nomor3#bet+
                    nomor1*nomor2#bet</p>
                  <p>Contoh Penulisan: 123*1234*12#5+11*  222*333#1+33*777#2</p>
                </div>
                <div className='rules_conversion'>
                  <p>Konversi <br /> 1 = {multipleValue}</p>
                </div>
              </div>
              : ""}
          </>
        ) : null
      }

      <div className="tabcontent-wrapper">
        {activeTab === 1 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <FourDThreeDTwoDBetDiscountVersiWap /> : <Bet_Diskon />))}</div>}
        {activeTab === 2 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <FourDThreeDTwoDBetFullVersiWap /> : <Bet_Full />))}</div>}
        {activeTab === 3 && <div>{(marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> : (app_type == 'wap' ? <FourDThreeDTwoDPrizeVersiWap /> : <Prize />))}</div>}
      </div>

    </>

  );
};

export default withTranslation()(FourDThreeDTwoD);